// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export const PhoneNumbersService = {
    ListSMSPhoneNumbers(fn, req) {
        return fn(`/phone-exp/phone-numbers/v1/sms-phone-numbers?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    SetSMSPhoneNumber(fn, req) {
        try {
            fm.validateUrlParam(req["phoneNumberId"], "phoneNumberId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone-exp/phone-numbers/v1/sms-phone-number/${req["phoneNumberId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * This endpoints returns a list of default voice phone numbers along with location-id that are eligible to be used for a sip profile.
     */
    ListVoicePhoneNumbers(fn, req) {
        return fn(`/phone-exp/phone-numbers/voice-phone-numbers?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ListForwardingNumbers by tenant. This is an NWX endpoint and so authorization needs to be done
     * within the service.
     * This endpoint is only accessible by users that have the PHONE_FULL_ACCESS permission for the
     * given tenant in the request.
     */
    ListForwardingNumbers(fn, req) {
        return fn(`/phone-exp/phone-numbers/forwarding-numbers?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ListPhoneNumbersForLocations lists all phone numbers for locations passed in the request, including both location-id labeled
     * phone numbers and un-labeled numbers on the associated phone tenant.
     *
     * Note: This is endpoint is not tenant-based because it's part of organziation settings and is shared by Phone, Messaging and Fax.
     * Authorization needs to be done within the service.
     *
     * GET: /phone/phone-exp/phone-numbers/list?{locationIds}
     */
    ListPhoneNumbersForLocations(fn, req) {
        return fn(`/phone-exp/phone-numbers/list?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Note: This is endpoint is not tenant-based because it's part of organziation settings and is shared by Phone, Messaging and Fax.
     * Authorization needs to be done within the service.
     * PUT: /phone-exp/phonenumbers/default-sms
     */
    SetLocationSms(fn, req) {
        return fn(`/phone-exp/phone-numbers/default-sms`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    ListBlockedNumbers(fn, req) {
        return fn(`/phone-exp/phone-numbers/blocked-numbers?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    CreateBlockedNumber(fn, req) {
        return fn(`/phone-exp/phone-numbers/blocked-numbers`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteBlockedNumber(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone-exp/phone-numbers/blocked-numbers/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "DELETE" });
    },
};
